module.exports = __webpack_public_path__ + "img/s_0.881da0ca.jpg";